const el = {
  root: document.querySelector<HTMLDivElement>('.user-tooltip'),
  trigger: document.querySelector<HTMLAnchorElement>('#user-login-button'),
  triggerMobile: document.querySelector<HTMLAnchorElement>('#user-login-button-mobile'),
}

let delayedMouseOut;

export const UserTooltip = {
  init: () => {
    if (!el.root || !el.trigger) return
    el.root.addEventListener('mouseenter', UserTooltip.onMouseEnter)
    el.root.addEventListener('mouseleave', UserTooltip.onMouseLeave)
    el.trigger.addEventListener('mouseenter', UserTooltip.onMouseEnter)
    el.trigger.addEventListener('mouseleave', UserTooltip.onMouseLeave)

    el.triggerMobile.addEventListener('click', UserTooltip.onClick)
    window.addEventListener('click', UserTooltip.onOutsideClick)
  },

  onMouseEnter: () => {
    if (UserTooltip.isOnMobile()) return

    el.root.classList.add('user-tooltip--visible')
    clearTimeout(delayedMouseOut)
  },

  onMouseLeave: () => {
    if (UserTooltip.isOnMobile()) return

    delayedMouseOut = setTimeout(() => {
      el.root.classList.remove('user-tooltip--visible')
    }, 350);
  },

  onClick: (e: Event & { target: HTMLAnchorElement }) => {
    // if user is logged in we prevent default behavior
    if (e.target.dataset.authenticated === 'true') {
      e.preventDefault()
    }

    UserTooltip.adjustTooltipPosition()

    if (el.root.classList.contains('user-tooltip--visible')) {
      el.root.classList.remove('user-tooltip--visible')
      return
    }
    el.root.classList.add('user-tooltip--visible')
  },

  isOnMobile: () => {
    const { innerWidth } = window
    return innerWidth < 768
  },

  onOutsideClick: (e: Event & { target: Element }) => {
    if (!UserTooltip.isOnMobile()) return

    const isClickInside = el.root.contains(e.target) || el.triggerMobile.contains(e.target)
    if (isClickInside) return
    el.root.classList.remove('user-tooltip--visible')
  },

  adjustTooltipPosition: () => {
    const { innerWidth } = window
    const cartButtonIsVisible = !document.querySelector<HTMLLIElement>('#cart-button-wrapper')?.classList?.contains('header__item--hide') || false

    // remove styles
    if (innerWidth >= 576 || !cartButtonIsVisible) {
      el.root.classList.remove('user-tooltip--besides-cart-button')
      return
    }

    el.root.classList.add('user-tooltip--besides-cart-button')
  },

}